// Clipboard write shaped so iOS Safari also accepts it. Mirrors the proven
// implementation on the invite screen.
export const writeToClipboard = async (text) => {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (err) {
    console.warn('[clipboard] api rejected:', err?.name, err?.message);
  }
  try {
    const field = document.createElement('textarea');
    field.value = text;
    field.contentEditable = 'true';
    field.readOnly = false;
    field.style.position = 'fixed';
    field.style.top = '0';
    field.style.opacity = '0';
    document.body.appendChild(field);
    const range = document.createRange();
    range.selectNodeContents(field);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    field.setSelectionRange(0, text.length);
    const ok = document.execCommand('copy');
    selection.removeAllRanges();
    document.body.removeChild(field);
    return ok;
  } catch (err) {
    console.warn('[clipboard] execCommand threw:', err?.name, err?.message);
    return false;
  }
};
